import { makeStyles } from '../styles';
import { hexToRgba } from '../utils/hexToRgba';

export const useSliderStyles = makeStyles([
  [
    'rail',
    (theme, [vertical, size]) => [
      `
			position: absolute;
			background-color: ${theme.color.primary.background};
			border-radius: ${size}px;
			transition: background-color .3s;
		`,
      !vertical
        ? `
			width: 100%;
			height: ${size}px;
		`
        : `
			width: ${size}px;
			height: 100%;
		`
    ]
  ],
  [
    'track',
    (theme, [vertical, size]) => [
      `
			position: absolute;
			border-radius: ${size}px;
			background-color: ${theme.color.primary.hover};
			transition: background-color 0.3s ease;
		`,
      !vertical
        ? `
			top: ${size}px;
			height: ${size}px;
		`
        : `
			left: ${size}px;
			width: ${size}px;
		`
    ]
  ],
  [
    'handler',
    (theme, [vertical, size, handlerSize]) => [
      `
			position: absolute;
			width: ${handlerSize}px;
			height: ${handlerSize}px;
			background-color: ${theme.color.text.white};
			border-color: ${theme.color.primary.hover};
			border-width: 3px;
			border-style: solid;
			border-radius: 50%;
			transition: border-color 0.3s, box-shadow 0.6s, transform 0.3s cubic-bezier(.18, .89, .32, 1.28);
			box-sizing: border-box;

			&:focus,
			&:active {
				border-color: ${theme.color.primary.default};
				outline: none;
				box-shadow: 0 0 0 ${size}px ${hexToRgba(theme.color.primary.default, 0.2)};
			}
		`,
      !vertical
        ? `
			transform: translateX(-50%);
			top: 0;
		`
        : `
			transform: translateY(-50%);
			left: 0;
		`
    ]
  ],
  [
    'slider',
    (theme, [vertical, size, handlerSize, hasMarks], classes) => [
      `
			position: relative;
			border-radius: 3px;
			margin: ${handlerSize / 2}px;
			touch-action: none;
			cursor: pointer;
			box-sizing: border-box;

			&:hover {
				.${classes.track} {
					background-color: ${theme.color.primary.default};
				}
			}
		`,
      !vertical &&
        `
			padding: ${(handlerSize - size) / 2}px 0;
			height: ${handlerSize}px;
		`,
      vertical &&
        `
			padding: 0 ${(handlerSize - size) / 2}px;
			width: ${handlerSize}px;
			height: 100%;
		`,
      hasMarks &&
        !vertical &&
        `
			margin-bottom: ${handlerSize * 1.25}px;
		`,
      hasMarks &&
        vertical &&
        `
			margin-right: ${handlerSize * 1.25}px;
		`
    ]
  ]
]);
